import React from 'react';
import {
  IonIcon,
  IonLabel,
  IonTabs,
  IonTabBar,
  IonTabButton,
  IonRouterOutlet
} from '@ionic/react';
import { mail, pencil } from 'ionicons/icons';
import { connect } from 'react-redux'
import './Messenger.css';

import { Route, Redirect } from "react-router";

import Received from './Received';
import Sent from './Sent';

import IndexActions from '../../../actions/index';

class Menssenger extends React.Component {
  constructor(props: any) {
    super(props)
    this.state = {}
  }

  closeModal() {
   console.log(this.props)
   //this.props.getMe()
  }

  render() {
    return (
      <IonTabs>

        <IonRouterOutlet>
          <Route path="/messenger/received" component={Received}  />
          <Route path="/messenger/sent" component={Sent} />
          <Route path="/" render={() => <Redirect to="/messenger/received" />} exact={true} /> 
        </IonRouterOutlet>

        <IonTabBar slot="bottom">
          <IonTabButton tab="received" href="/messenger/received">
            <IonIcon icon={mail} />
            <IonLabel>Recibidos</IonLabel>
          </IonTabButton>
          <IonTabButton tab="sent" href="/messenger/sent">
            <IonIcon icon={pencil} />
            <IonLabel>Enviados</IonLabel>
          </IonTabButton>
        </IonTabBar>

      </IonTabs>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    data: state.data
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getMe: () => dispatch(IndexActions.getMe())
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Menssenger);
